// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__ltErI","userModule":"Nav_userModule__lpK+y","burgerBtn":"Nav_burgerBtn__X+loE","burgerMenu":"Nav_burgerMenu__PDjEb","burgerMenuContent":"Nav_burgerMenuContent__2SQdf"};